module.exports = __webpack_public_path__ + "static/media/icon-header-engagement.32688883.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/views/HeaderNoLogout/assets/icon-header-engagement.svg
// module id = 1847
// module chunks = 193